import { render, staticRenderFns } from "./index-skeleton.vue?vue&type=template&id=2d95f0ac&scoped=true&"
import script from "./index-skeleton.vue?vue&type=script&lang=js&"
export * from "./index-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./index-skeleton.vue?vue&type=style&index=0&id=2d95f0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95f0ac",
  null
  
)

export default component.exports